import { READ_PERMISSIONS_LIST, WRITE_PERMISSIONS_LIST } from '../../utils/constants/permissions'

const ADMIN_PERMISSIONS = [
  READ_PERMISSIONS_LIST.impersonate.name,
  READ_PERMISSIONS_LIST.folders.name,
  READ_PERMISSIONS_LIST.subscriptions.name,
  READ_PERMISSIONS_LIST.notificationSchemas.name,
  READ_PERMISSIONS_LIST.insights.name,
  READ_PERMISSIONS_LIST.protect.name,
  WRITE_PERMISSIONS_LIST.folders.name,
  WRITE_PERMISSIONS_LIST.subscriptions.name,
  WRITE_PERMISSIONS_LIST.notificationSchemas.name,
  WRITE_PERMISSIONS_LIST.folderAttributes.name,
]

export default ADMIN_PERMISSIONS
